export const userEntered = (arr: any, user: any) => {
  const newUser = {
    id: user.player_id,
    name: user.player_name,
    bet: null,
    cashout: user.cashout,
  }

  const isThereAlready = arr.some((u: any) => u.id === user.player_id)
  if (!isThereAlready) {
    arr.push(newUser)
  }
  return arr
}

export const userPlacedBet = (arr: any, user: any) => {
  const mapped = arr.map((u: any) =>
    u.id !== user.player_id
      ? u
      : {
        ...u,
        bet: user.bet,
        currency: user.currency,
      },
  )

  return sortArray(mapped)
}

export const userCanceledBet = (arr: any, user: any) => {
  return arr.map((u: any) =>
    u.id !== user.player_id ? u : { ...u, bet: null },
  )
}

export const userExited = (arr: any, user: any) =>
  arr.filter((u: any) => u.id !== user.player_id)

export const userCashouted = (arr: any, user: any, prec: any) => {
  return arr.map((u: any) =>
    u.id === user.player_id
      ? {
        ...u,
        bet: user.bet,
        cashout: user.cashout.toFixed(prec),
        currency: user.currency,
      }
      : u,
  )
}

export const roundReset = (users: any) =>
  users.map((u: any) => {
    return { ...u, bet: null, currency: null, cashout: null }
  })

export const firstUserPush = (
  id: string,
  name: string,
  setusers: (a: any) => void,
) => {
  setusers([
    {
      id,
      name,
      bet: null,
      cashout: null,
    },
  ])
}

const sortArray = (arr: any) =>
  arr.sort((a: any, b: any) => +a.bet - +b.bet).reverse()
